export const OPERATIONS_ROLES: { [prop in OperationsRole]: prop } = {
  client_ops: 'client_ops',
  writer_ops: 'writer_ops',
  editor_ops: 'editor_ops',
  translation_ops: 'translation_ops',
  supply_ops: 'supply_ops',
  designer_ops: 'designer_ops',
  payment_ops: 'payment_ops'
}

export const CREATOR_ROLES: { [prop in CreatorRole]: prop } = {
  writer: 'writer',
  editor: 'editor',
  translator: 'translator',
  designer: 'designer',
  other: 'other'
}

export const BUSINESS_ROLES: { [prop in BusinessRole]: prop } = {
  client: 'client'
}

export const USER_ROLES: { [prop in UserRole]: prop } = {
  ...BUSINESS_ROLES,
  ...CREATOR_ROLES,
  ...OPERATIONS_ROLES
}
